/* Startseite: drei ausgewaehlte Fragen stehen immer sichtbar, der Rest
   klappt ueber einen Button auf. Dazu die Spruenge zu Kacheln (#angebot),
   FAQ (#faq) und Newsletter (#newsletter), auch von anderen Seiten aus. */
(function () {
  /* Diese drei Fragen erscheinen als Vorschau, in dieser Reihenfolge.
     Es genuegt ein eindeutiger Ausschnitt der Frage. Wird eine nicht
     gefunden, ruecken die uebrigen Fragen von oben nach. */
  var VORSCHAU = [
    'Wie erhalte ich die Tickets',
    'Muss ich das PDF-Ticket ausdrucken',
    'Wo finde ich die Teilnahmebedingungen'
  ];

  /* ---------- FAQ ---------- */
  function faqBauen(sec) {
    if (!sec || sec.getAttribute('data-lr-faq') === 'on') return;
    var grid = sec.querySelector('.collapsible-content__grid');
    if (!grid) return;
    sec.setAttribute('data-lr-faq', 'on');

    var karten = [];
    var alle = grid.querySelectorAll('.accordion');
    for (var k = 0; k < alle.length; k++) karten.push(alle[k]);

    function titelVon(karte) {
      var t = karte.querySelector('.accordion__title');
      return (t ? t.textContent : karte.textContent).toLowerCase();
    }

    /* Die gewuenschten Fragen heraussuchen */
    var gewaehlt = [];
    for (var v = 0; v < VORSCHAU.length; v++) {
      var suche = VORSCHAU[v].toLowerCase();
      for (var i = 0; i < karten.length; i++) {
        if (gewaehlt.indexOf(karten[i]) !== -1) continue;
        if (titelVon(karten[i]).indexOf(suche) !== -1) {
          gewaehlt.push(karten[i]);
          break;
        }
      }
    }
    /* Fehlende Plaetze von oben auffuellen */
    for (var f = 0; f < karten.length && gewaehlt.length < VORSCHAU.length; f++) {
      if (gewaehlt.indexOf(karten[f]) === -1) gewaehlt.push(karten[f]);
    }

    var oben = document.createElement('div');
    oben.className = 'lr-faq-top';
    grid.parentNode.insertBefore(oben, grid);
    for (var g = 0; g < gewaehlt.length; g++) oben.appendChild(gewaehlt[g]);

    /* Der Rest liegt im ausklappbaren Bereich */
    var panel = document.createElement('div');
    panel.className = 'lr-faq-panel';
    panel.id = 'lr-faq-panel';
    panel.hidden = true;
    grid.parentNode.insertBefore(panel, grid);
    panel.appendChild(grid);

    var opener = document.createElement('button');
    opener.type = 'button';
    opener.className = 'lr-button lr-button--outline lr-faq-open';
    opener.setAttribute('aria-expanded', 'false');
    opener.setAttribute('aria-controls', 'lr-faq-panel');
    opener.innerHTML = '<span class="lr-faq-open__label">Alle Fragen ansehen</span>' +
      '<svg class="lr-faq-open__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var label = opener.querySelector('.lr-faq-open__label');
    panel.parentNode.insertBefore(opener, panel.nextSibling);

    /* Ohne weitere Fragen braucht es den Button nicht */
    if (karten.length <= gewaehlt.length) {
      opener.hidden = true;
      return;
    }

    opener.addEventListener('click', function () {
      if (panel.hidden) {
        panel.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        label.textContent = 'Weniger anzeigen';
      } else {
        panel.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        label.textContent = 'Alle Fragen ansehen';
        var auf = panel.querySelectorAll('details[open]');
        for (var i = 0; i < auf.length; i++) auf[i].removeAttribute('open');
      }
    });
  }

  /* ---------- Sprungziele ----------
     Die Section-IDs der Startseite tragen den Vorlagen-Namen im Namen und
     sind deshalb keine verlaesslichen Anker. Stattdessen: #angebot -> Kacheln,
     #faq -> Haeufige Fragen, #newsletter -> Newsletter. */
  function zielFuer(hash) {
    if (!hash) return null;
    if (hash.indexOf('#angebot') !== -1 || hash.indexOf('#shopify-section-lr_tiles') !== -1) {
      return document.querySelector('.lr-tiles');
    }
    if (hash.indexOf('#faq') !== -1 || hash.indexOf('collapsible_content') !== -1) {
      return document.querySelector('.collapsible-content');
    }
    if (hash.indexOf('#newsletter') !== -1) {
      return document.querySelector('.newsletter');
    }
    return null;
  }

  function springe(ziel, weich) {
    if (!ziel) return;
    ziel.scrollIntoView({ behavior: weich ? 'smooth' : 'auto', block: 'start' });
  }

  function sprungAktivieren() {
    document.addEventListener('click', function (e) {
      var el = e.target;
      var a = null;
      while (el && el !== document) {
        if (el.tagName === 'A') { a = el; break; }
        el = el.parentNode;
      }
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hashPos = href.indexOf('#');
      if (hashPos === -1) return;
      var pfad = href.slice(0, hashPos);
      if (pfad !== '' && pfad !== '/' && pfad !== location.pathname) return;
      var ziel = zielFuer(href.slice(hashPos));
      if (!ziel) return;
      e.preventDefault();
      springe(ziel, true);
    });
  }

  /* Von einer anderen Seite mit #faq, #angebot oder #newsletter angekommen */
  function hashSprung() {
    var ziel = zielFuer(location.hash);
    if (ziel) setTimeout(function () { springe(ziel, false); }, 60);
  }

  function init() {
    var liste = document.querySelectorAll('.collapsible-content');
    for (var i = 0; i < liste.length; i++) faqBauen(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); hashSprung(); });
  window.addEventListener('hashchange', hashSprung);
  document.addEventListener('shopify:section:load', init);
  sprungAktivieren();
})();
